import { Hidden } from '@ahmdigital/ui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { StepsWrapper } from './styles';
import { useByocNavigationContext } from '../../context/byoc-navigation-context';
import Animate from '../../../../components/animate';
import DesktopNavigation from './desktop-navigation';
import MobileExpandedNavigation from './mobile-expanded-navigation';
import MobileNavigation from './mobile-navigation';
import type { StepSlug } from '../../types';

const StyledDiv = styled.div`
  position: relative;
`;

const StepHeaderNavigation = () => {
  const [isMobileNavExpanded, setIsMobileNavExpanded] = useState(false);
  const { activeStep, goToStep } = useByocNavigationContext();

  useEffect(() => {
    setIsMobileNavExpanded(false);
    window.scrollTo(0, 0);
  }, [activeStep]);

  const handleGoToStep = (slug: StepSlug) => {
    setIsMobileNavExpanded(false);
    goToStep(slug);
  };

  return (
    <StyledDiv>
      <StepsWrapper>
        <Hidden isBlock xs sm md>
          <DesktopNavigation handleGoToStep={handleGoToStep} />
        </Hidden>
        <Hidden isBlock lg df>
          <MobileNavigation isMobileNavExpanded={isMobileNavExpanded} setIsMobileNavExpanded={setIsMobileNavExpanded} />
        </Hidden>
      </StepsWrapper>
      <Hidden isBlock lg df>
        <Animate isVisible={isMobileNavExpanded}>
          <MobileExpandedNavigation handleGoToStep={handleGoToStep} />
        </Animate>
      </Hidden>
    </StyledDiv>
  );
};

export default StepHeaderNavigation;
